import {
    Avatar, Button, Clickable, Col, Divider,
    Modal, Row,
    Text
} from 'components';
import { Api, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';


const CustomInput = styled.input`
  width: 40px;
  height: 20px;
  padding: 2px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

let timer;
const Item = ({ item, teamId, filterAthletes, athletes }) => {
  const [visible, setVisible] = useState(false),
    [number, setNumber] = useState(''),
    [position, setPosition] = useState(''),
    { t } = useTranslation(),
    dispatch = useDispatch();

  useEffect(() => {
    handleNumberChange();
  }, []);

  useEffect(() => {
    setNumber(item.playerInfo?.number || '');
    setPosition(
      item.sports?.length && item.sports[0].position
        ? `${item.sports[0].sport}.${item.sports[0].position}`
        : ''
    );
  }, []);

  function handleVisible() {
    setVisible(!visible);
  }

  async function handleNumberChange({ target }) {
    const value = target?.value || '';
    setNumber(value);

    clearTimeout(timer);

    timer = setTimeout(() => {
      Api.post('/admin/updatePlayerNumber', { number: value, teamId, athleteId: item._id });
    }, 300);
  }

  async function remove() {
    const res = await Api.post(
      '/admin/removeFromTeam',
      { userId: item._id, teamId },
      'removeFromTeam'
    );
    if (!res) return;

    filterAthletes(item._id);

    dispatch({
      type: 'ADMIN_EDIT_USER',
      payload: { _id: teamId, athletes: athletes.filter((x) => x._id !== item._id) }
    });

    handleVisible();
  }

  return (
    <React.Fragment>
      <Row between pad="12px 24px">
        <Clickable>
          <Row center>
            <Avatar small user={item} avatar={item.avatar} />

            <Col center marg="0 0 0 8px" between noFlex>
              <Text b2>{item.name}</Text>
              <Text c1 med col={theme.GREY_60}>
                @{item.username}
              </Text>
            </Col>
          </Row>
        </Clickable>

        <Col noFlex between endAll>
          <Row centerAll>
            <Row noFlex centerAll>
              <Text c1 med align="right" right marg="0 10px 0">
                {t(position)}
              </Text>
            </Row>

            <Row noFlex centerAll>
              <Text marg="0 5px 0 0">#</Text>
              <CustomInput placeholder="10" onChange={handleNumberChange} value={number} />
            </Row>
          </Row>

          <Clickable onClick={handleVisible}>
            <Text c1 med col={theme.SECONDARY} right>
              Remove from team
            </Text>
          </Clickable>
        </Col>
      </Row>

      <Divider />

      <Modal visible={visible} closeModal={handleVisible}>
        <Col pad="34px 24px" center>
          <Text h3 center>
            Are you sure you want to remove this athlete?
          </Text>
          <Text center marg="24px 0 0">
            This action is irreversable.
          </Text>

          <Row marg="24px 0 0">
            <Button text="Cancel" onClick={handleVisible} marg="0 24px 0 0" />

            <Button text="Remove" bg={theme.SECONDARY} action="removeFromTeam" onClick={remove} />
          </Row>
        </Col>
      </Modal>
    </React.Fragment>
  );
};

export default Item;
